/* Classifiche (port di rankings.js) — top giocatori per centro + ranking personale. */
import { useEffect, useState } from "react";
import { ptapp } from "@/lib/ptapp";
import { Card, AccountSelect, Pill, COORD, T, asList } from "./_ui";

const SPORTS = ["PADEL", "PICKLEBALL", "TENNIS"];
const nameOf = (t: any) => t.tenant_name || t.name || "Centro";
const cityOf = (t: any) => { const a = t.address || {}; return a.city || a.postal_code || a.street || t.city || ""; };
const pName = (p: any) => { const u = p.user || p.player || p; return u.full_name || u.name || u.display_name || ((u.first_name || "") + " " + (u.last_name || "")).trim() || (u.user_id || u.id || "Giocatore"); };
const pCount = (p: any) => { const v = p.matches ?? p.match_count ?? p.count ?? p.number_of_matches ?? p.played_matches ?? p.total_matches; return v != null ? v : null; };

export default function Rankings() {
  const [acct, setAcct] = useState("moving");
  const [tenants, setTenants] = useState<any[]>([]);
  const [tid, setTid] = useState("");
  const [sport, setSport] = useState("PADEL");
  const [rows, setRows] = useState<any[] | null>(null);
  const [me, setMe] = useState<any[] | null>(null);

  useEffect(() => {
    ptapp.call<any>(acct, "api", "v1/tenants", { params: { coordinate: COORD, radius: 25000, size: 60 } }).then((r) => {
      let arr = asList(r);
      arr.sort((a, b) => { const ia = a.tenant_id || a.id, ib = b.tenant_id || b.id; if (ia === T) return -1; if (ib === T) return 1; return nameOf(a).localeCompare(nameOf(b)); });
      setTenants(arr); if (arr.length) setTid(arr.find((x) => (x.tenant_id || x.id) === T) ? T : (arr[0].tenant_id || arr[0].id));
    }).catch(() => setTenants([]));
  }, [acct]);

  useEffect(() => {
    if (!tid) return; setRows(null);
    ptapp.call<any>(acct, "app", "v1/matches_summary/top_players_by_tenant", { params: { tenant_id: tid, sport_id: sport, size: 25 } })
      .then((r) => { let a = asList(r); a = a.slice().sort((x, y) => (pCount(y) ?? 0) - (pCount(x) ?? 0)); setRows(a); }).catch(() => setRows([]));
  }, [acct, tid, sport]);

  useEffect(() => {
    ptapp.uid(acct).then((u) => ptapp.call<any>(acct, "app", "v1/user_rankings", { params: { user_id: u.uid, sport_id: sport } })
      .then((r) => setMe(asList(r).length ? asList(r) : (r ? [r] : []))).catch(() => setMe([]))).catch(() => setMe([]));
  }, [acct, sport]);

  return (
    <div className="mx-auto max-w-3xl space-y-4 p-4">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="mr-2 text-lg font-bold text-slate-900">Classifiche</h2>
        <AccountSelect value={acct} onChange={setAcct} />
        <select value={tid} onChange={(e) => setTid(e.target.value)} className="rounded-md border border-slate-300 px-2 py-1.5 text-sm min-w-[200px]">
          {tenants.map((t) => { const id = t.tenant_id || t.id; const c = cityOf(t); return <option key={id} value={id}>{nameOf(t)}{c ? ` (${c})` : ""}</option>; })}
        </select>
        <select value={sport} onChange={(e) => setSport(e.target.value)} className="rounded-md border border-slate-300 px-2 py-1.5 text-sm">
          {SPORTS.map((s) => <option key={s}>{s}</option>)}
        </select>
      </div>

      <Card title={`Top giocatori — ${sport}`}>
        {rows == null ? <div className="text-sm text-slate-500">carico…</div> :
          rows.length === 0 ? <div className="text-sm text-slate-500">Nessun giocatore in classifica.</div> : (
            <div className="space-y-1">
              {rows.map((p, i) => (
                <div key={i} className="flex items-center justify-between gap-3 py-0.5">
                  <span className="text-sm text-slate-800"><b>#{i + 1}</b> {pName(p)}</span>
                  {pCount(p) != null ? <Pill>{pCount(p)} partite</Pill> : null}
                </div>
              ))}
            </div>
          )}
      </Card>

      <Card title="Il mio ranking">
        {me == null ? <div className="text-sm text-slate-500">carico…</div> :
          me.length === 0 ? <div className="text-sm text-slate-500">Nessun ranking personale disponibile.</div> : (
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
              {me.map((r, i) => {
                const sp = r.sport_id || r.sport || sport, lvl = r.level ?? r.ranking ?? r.value, pos = r.position ?? r.rank;
                return <div key={i} className="rounded-lg border border-slate-200 p-2"><div className="flex items-center justify-between"><b className="text-sm text-slate-800">{sp}</b>{lvl != null ? <Pill tone="green">livello {String(lvl)}</Pill> : null}</div>{pos != null ? <div className="text-xs text-slate-400">posizione {String(pos)}</div> : null}</div>;
              })}
            </div>
          )}
      </Card>
    </div>
  );
}
